module.exports = __webpack_public_path__ + "img/medal.4d4c28cb.png";